import React, { useState } from "react";
import ResearchLayout, { useReveal } from "../ResearchLayout";
import makeRequest from "../../../makeRequest";

export default function Contact() {
  useReveal();
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError("");
    setSubmitting(true);
    try {
      await makeRequest({
        route: "/website/contact-message/public",
        method: "post",
        data: {
          name: form.name,
          email: form.email,
          subject: form.subject,
          comments: form.message,
          type: "research",
        },
      });
      setSubmitted(true);
      setTimeout(() => {
        setForm({ name: "", email: "", subject: "", message: "" });
        setSubmitted(false);
      }, 5000);
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to send message. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ResearchLayout>
      <section
        style={{
          padding: "100px 0 60px",
          background: "linear-gradient(135deg, #0d3b6e 0%, #076cec 100%)",
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="rs-blob" style={{ width: 400, height: 400, background: "#04b3bf", top: "-150px", right: "-100px" }} />
        <div className="rs-container rs-text-center" style={{ position: "relative", zIndex: 2 }}>
          <span className="rs-section-eyebrow" style={{ background: "rgba(255,255,255,0.15)", color: "#fff", backdropFilter: "blur(10px)" }}>
            Get In Touch
          </span>
          <h1 style={{ fontSize: "clamp(2rem, 5vw, 3.4rem)", fontWeight: 800, margin: "12px 0 16px" }}>Contact Research Team</h1>
          <p style={{ fontSize: "1.05rem", maxWidth: 700, margin: "0 auto", opacity: 0.85, lineHeight: 1.7 }}>
            Reach out for sponsorships, collaborations, trial inquiries, or career opportunities at the Clinical Trial Unit.
          </p>
        </div>
      </section>

      <section className="rs-section" style={{ paddingTop: 60 }}>
        <div className="rs-container">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1.4fr",
              gap: 40,
            }}
            className="rs-contact-grid"
          >
            {/* Info */}
            <div className="rs-reveal">
              <h2 style={{ fontSize: "1.6rem", fontWeight: 800, color: "var(--rs-dark)", margin: "0 0 24px" }}>Reach us directly</h2>

              {[
                {
                  icon: "fa-location-dot",
                  title: "Address",
                  body: "Maroof International Hospital, F-10 Markaz, Islamabad, Pakistan",
                },
                {
                  icon: "fa-phone",
                  title: "Phone",
                  body: "+92 51 2222911",
                },
                {
                  icon: "fa-envelope",
                  title: "Email",
                  body: "research@maroofhospital.com",
                },
                {
                  icon: "fa-clock",
                  title: "Office Hours",
                  body: "Mon - Fri · 9:00 AM - 5:00 PM",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  style={{
                    display: "flex",
                    gap: 16,
                    padding: "18px 20px",
                    borderRadius: 14,
                    background: "linear-gradient(135deg, #f0f7ff, #e6fffa)",
                    border: "1px solid rgba(7, 108, 236,0.08)",
                    marginBottom: 14,
                    transition: "transform 0.25s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "translateX(6px)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "translateX(0)")}
                >
                  <div
                    style={{
                      flexShrink: 0,
                      width: 44,
                      height: 44,
                      borderRadius: 12,
                      background: "var(--rs-grad-1)",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i className={`fa-regular ${item.icon}`}></i>
                  </div>
                  <div>
                    <div
                      style={{ fontSize: "0.78rem", color: "#6b7280", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }}
                    >
                      {item.title}
                    </div>
                    <div style={{ fontSize: "0.95rem", color: "var(--rs-dark)", fontWeight: 600, marginTop: 3 }}>{item.body}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Form */}
            <div
              className="rs-reveal delay-2"
              style={{
                background: "#fff",
                borderRadius: 22,
                padding: 36,
                border: "1px solid rgba(7, 108, 236,0.08)",
                boxShadow: "0 16px 40px rgba(7, 108, 236,0.06)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -60,
                  right: -60,
                  width: 200,
                  height: 200,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, rgba(7, 108, 236,0.06), rgba(4, 179, 191,0.06))",
                }}
              />

              <h2 style={{ fontSize: "1.5rem", fontWeight: 800, color: "var(--rs-dark)", margin: "0 0 8px", position: "relative" }}>
                Send a Message
              </h2>
              <p style={{ color: "#6b7280", margin: "0 0 24px", position: "relative" }}>We'll respond within 1-2 business days.</p>

              {submitted ? (
                <div
                  style={{
                    padding: "60px 20px",
                    textAlign: "center",
                    animation: "rsScaleIn 0.4s ease",
                  }}
                >
                  <div
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #10b981, #047857)",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "2rem",
                      margin: "0 auto 18px",
                    }}
                  >
                    <i className="fa-regular fa-check"></i>
                  </div>
                  <h3 style={{ fontSize: "1.3rem", fontWeight: 800, color: "var(--rs-dark)", margin: "0 0 6px" }}>Thank you!</h3>
                  <p style={{ color: "#6b7280", margin: 0 }}>Your message has been received. Our team will reach out shortly.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} style={{ position: "relative", display: "grid", gap: 16 }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }} className="rs-form-row">
                    <Field label="Your Name" name="name" value={form.name} onChange={handleChange} required />
                    <Field label="Email Address" name="email" type="email" value={form.email} onChange={handleChange} required />
                  </div>
                  <Field label="Subject" name="subject" value={form.subject} onChange={handleChange} required />
                  <div>
                    <label style={fieldLabelStyle}>Message</label>
                    <textarea
                      name="message"
                      value={form.message}
                      onChange={handleChange}
                      required
                      rows={5}
                      style={{ ...fieldInputStyle, resize: "vertical", minHeight: 130 }}
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={submitting}
                    className="rs-btn rs-btn-primary"
                    style={{
                      marginTop: 6,
                      justifySelf: "start",
                      opacity: submitting ? 0.7 : 1,
                      cursor: submitting ? "not-allowed" : "pointer",
                    }}
                  >
                    {submitting ? "Sending..." : "Send Message"}
                    <i className={`fa-regular ${submitting ? "fa-spinner fa-spin" : "fa-paper-plane"}`}></i>
                  </button>
                  {error && (
                    <div
                      style={{
                        marginTop: 8,
                        color: "#b91c1c",
                        background: "#fef2f2",
                        border: "1px solid #fecaca",
                        padding: "10px 14px",
                        borderRadius: 10,
                        fontSize: "0.9rem",
                      }}
                    >
                      {error}
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>

          <style>{`
            @media (max-width: 900px) {
              .rs-contact-grid { grid-template-columns: 1fr !important; }
              .rs-form-row { grid-template-columns: 1fr !important; }
            }
          `}</style>
        </div>
      </section>
    </ResearchLayout>
  );
}

const fieldLabelStyle = {
  display: "block",
  fontSize: "0.78rem",
  fontWeight: 700,
  color: "#374151",
  marginBottom: 6,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
};

const fieldInputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 10,
  border: "1.5px solid #e5e7eb",
  fontSize: "0.92rem",
  color: "#1a2744",
  fontFamily: "inherit",
  outline: "none",
  transition: "border-color 0.2s, box-shadow 0.2s",
};

function Field({ label, ...props }) {
  return (
    <div>
      <label style={fieldLabelStyle}>{label}</label>
      <input
        {...props}
        style={fieldInputStyle}
        onFocus={(e) => {
          e.target.style.borderColor = "var(--rs-primary)";
          e.target.style.boxShadow = "0 0 0 3px rgba(7, 108, 236,0.1)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#e5e7eb";
          e.target.style.boxShadow = "none";
        }}
      />
    </div>
  );
}
